import { defineMessages } from "react-intl";

// Field names, options and settings labels of the employee portal.
export const portalLabels = defineMessages({
  fullName: { defaultMessage: "Full name", id: "xnMPZf", description: "portal label" },
  username: { defaultMessage: "Username", id: "Xu/rNk", description: "portal label" },
  personalEmail: { defaultMessage: "Personal email", id: "FJ93Mk", description: "portal label" },
  personalEmailHint: {
    defaultMessage: "Personal email (password reset, monthly summaries)",
    id: "rV0e8M",
    description: "portal label",
  },
  phone: { defaultMessage: "Phone", id: "igm2nO", description: "portal label" },
  address: { defaultMessage: "Address", id: "xEJZox", description: "portal label" },
  postalCode: { defaultMessage: "Postal code", id: "TWl7Ht", description: "portal label" },
  city: { defaultMessage: "Town", id: "u3qGa9", description: "portal label" },
  nif: { defaultMessage: "Tax number (NIF)", id: "BaNgVb", description: "portal label" },
  niss: { defaultMessage: "Social security (NISS)", id: "k8YVKi", description: "portal label" },
  birthDate: { defaultMessage: "Date of birth", id: "C4IFE1", description: "portal label" },
  emergencyContactName: {
    defaultMessage: "Emergency contact",
    id: "mb9Tb1",
    description: "portal label",
  },
  emergencyContactPhone: {
    defaultMessage: "Emergency phone",
    id: "kqsJ16",
    description: "portal label",
  },
  jobTitle: { defaultMessage: "Job title", id: "Se60HB", description: "portal label" },
  hireDate: { defaultMessage: "Hire date", id: "XmPAL2", description: "portal label" },
  terminationDate: { defaultMessage: "Contract end", id: "rQHOYQ", description: "portal label" },
  weeklyHours: { defaultMessage: "Hours/week", id: "AHOWNZ", description: "portal label" },
  dailyHours: { defaultMessage: "Hours/day", id: "n4787j", description: "portal label" },
  annualVacationDays: {
    defaultMessage: "Vacation days/year",
    id: "Lg+lx7",
    description: "portal label",
  },
  manager: { defaultMessage: "Manager", id: "L25/wK", description: "portal label" },
  directManager: { defaultMessage: "Direct manager", id: "Ie9dR8", description: "portal label" },
  allManagement: {
    defaultMessage: "— (all management)",
    id: "oZkgFA",
    description: "portal label",
  },
  workSite: { defaultMessage: "Work site", id: "Iea7VR", description: "portal label" },
  normalPeriod: {
    defaultMessage: "Normal working period",
    id: "mCgAT0",
    description: "portal label",
  },
  normalPeriodValue: {
    defaultMessage: "{weekly} h/week · {daily} h/day",
    id: "d6w/I1",
    description: "portal label",
  },
  schedule: { defaultMessage: "Schedule", id: "yWstVa", description: "portal label" },
  scheduleType: { defaultMessage: "Schedule type", id: "0cw7Io", description: "portal label" },
  scheduleFixed: { defaultMessage: "Fixed hours", id: "MpWbEw", description: "portal label" },
  scheduleShifts: { defaultMessage: "Shifts", id: "7UiGjJ", description: "portal label" },
  scheduleExempt: {
    defaultMessage: "Exempt from fixed hours",
    id: "7CuZMd",
    description: "portal label",
  },
  telework: { defaultMessage: "Telework", id: "vN58nU", description: "portal label" },
  kindVacation: { defaultMessage: "Vacation", id: "aAAYS4", description: "portal label" },
  kindSickLeave: { defaultMessage: "Sick leave", id: "uw3BYe", description: "portal label" },
  kindJustified: { defaultMessage: "Justified absence", id: "dRFoDo", description: "portal label" },
  kindUnjustified: {
    defaultMessage: "Unjustified absence",
    id: "UcILQC",
    description: "portal label",
  },
  kindParental: { defaultMessage: "Parental leave", id: "9vC1oV", description: "portal label" },
  kindOther: { defaultMessage: "Other", id: "AIcQlk", description: "portal label" },
  statusPending: { defaultMessage: "Pending", id: "QGNvaJ", description: "portal label" },
  statusApproved: { defaultMessage: "Approved", id: "2koeFp", description: "portal label" },
  statusRejected: { defaultMessage: "Refused", id: "27Oevt", description: "portal label" },
  statusCancelled: { defaultMessage: "Cancelled", id: "b8g5ur", description: "portal label" },
  clsOvertime: { defaultMessage: "overtime", id: "vWDib5", description: "portal label" },
  clsPresence: {
    defaultMessage: "presence without work",
    id: "wJSPQs",
    description: "portal label",
  },
  clsUnauthorized: {
    defaultMessage: "unauthorised stay",
    id: "W4XnQ+",
    description: "portal label",
  },
  clsAdjustment: { defaultMessage: "adjustment", id: "1l2VIx", description: "portal label" },
  clsTimeBank: { defaultMessage: "time bank", id: "E0JyFY", description: "portal label" },
  clsJustified: { defaultMessage: "justified absence", id: "AHtibM", description: "portal label" },
  clsUnjustified: {
    defaultMessage: "unjustified absence",
    id: "YEPD/S",
    description: "portal label",
  },
  clsCompensation: {
    defaultMessage: "agreed compensation",
    id: "UGf68w",
    description: "portal label",
  },
  csvDate: { defaultMessage: "Date", id: "P/dIha", description: "portal label" },
  csvTime: { defaultMessage: "Time", id: "29eo4M", description: "portal label" },
  csvKind: { defaultMessage: "Kind", id: "xz3g3v", description: "portal label" },
  csvSeq: { defaultMessage: "Record no.", id: "as8izd", description: "portal label" },
  csvHash: { defaultMessage: "Verification code", id: "l0c7QL", description: "portal label" },
  csvCorrection: { defaultMessage: "Correction", id: "dZTCCp", description: "portal label" },
  csvReason: { defaultMessage: "Reason", id: "Z4Fp9Z", description: "portal label" },
  csvFlags: { defaultMessage: "Alerts", id: "EnAhPz", description: "portal label" },
  csvVoid: { defaultMessage: "voided", id: "gfMYj5", description: "portal label" },
  csvYes: { defaultMessage: "yes", id: "ZN26St", description: "portal label" },
  overstayLine: {
    defaultMessage: "planned end {end} · alert {alerted}",
    id: "i8kxeG",
    description: "portal label",
  },
  terminated: { defaultMessage: "contract ended", id: "jqe96H", description: "portal label" },
  rosterBase: { defaultMessage: "base", id: "UaCO+Z", description: "portal label" },
  dayOffOption: { defaultMessage: "Day off", id: "PTqtEe", description: "portal label" },
  baseScheduleOption: {
    defaultMessage: "Base schedule",
    id: "qqsBTK",
    description: "portal label",
  },
  rosterReason: {
    defaultMessage: "Reason for changes (if any)",
    id: "1pQqK6",
    description: "portal label",
  },
  lateNoticeWarning: {
    defaultMessage:
      "Some changes were published with less than the legal notice: they need the colaborador's agreement.",
    id: "Rjgvyq",
    description: "portal label",
  },
  color: { defaultMessage: "Colour", id: "9mQWaC", description: "portal label" },
  active: { defaultMessage: "Active", id: "cio6TV", description: "portal label" },
  latitude: { defaultMessage: "Latitude", id: "4BonUI", description: "portal label" },
  longitude: { defaultMessage: "Longitude", id: "2NhG2G", description: "portal label" },
  policyPrivacy: {
    defaultMessage: "Privacy notice (GDPR)",
    id: "B7OMJd",
    description: "portal label",
  },
  policyRegulation: {
    defaultMessage: "Internal regulation",
    id: "5VB520",
    description: "portal label",
  },
  policyConsent: { defaultMessage: "Optional consent", id: "76V7jV", description: "portal label" },
  ruleTolerance: { defaultMessage: "Tolerance (min)", id: "YhNCPm", description: "portal label" },
  ruleMinRest: {
    defaultMessage: "Minimum daily rest (h)",
    id: "Kqy8eE",
    description: "portal label",
  },
  ruleNotice: {
    defaultMessage: "Schedule change notice (days)",
    id: "3ogM1H",
    description: "portal label",
  },
  ruleAnnualOvertime: {
    defaultMessage: "Annual overtime limit (h)",
    id: "9vyFp/",
    description: "portal label",
  },
  ruleDailyOvertime: {
    defaultMessage: "Daily overtime limit (h)",
    id: "0ZEeRB",
    description: "portal label",
  },
  ruleToleranceCap: {
    defaultMessage: "Monthly tolerance cap (min)",
    id: "P84ylF",
    description: "portal label",
  },
  rulePatternDays: {
    defaultMessage: "Punctuality alert: days in 30",
    id: "ty+zcN",
    description: "portal label",
  },
  ruleLunchStart: { defaultMessage: "Lunch: start", id: "aLovdM", description: "portal label" },
  ruleLunchEnd: { defaultMessage: "Lunch: end", id: "xiQLS+", description: "portal label" },
  ruleTimeBank: {
    defaultMessage: "Time bank (only with IRCT / group regime)",
    id: "YRtvbl",
    description: "portal label",
  },
  ruleEntryPin: { defaultMessage: "Entry PIN", id: "FahieK", description: "portal label" },
  ruleLunchPin: { defaultMessage: "Lunch return PIN", id: "4w1hCk", description: "portal label" },
  language: { defaultMessage: "Language", id: "DWbYZE", description: "portal label" },
  absent: { defaultMessage: "Absent", id: "9ke0ff", description: "portal label" },
  noSite: { defaultMessage: "No site", id: "3FGW7B", description: "portal label" },
  err_pin_required: {
    defaultMessage: "Enter today's PIN.",
    id: "5Z9TpK",
    description: "portal label",
  },
  err_pin_invalid: { defaultMessage: "Wrong PIN.", id: "OwjI2e", description: "portal label" },
  err_pin_locked: {
    defaultMessage: "Too many wrong attempts today. Ask management to record your entry.",
    id: "Mzh0IV",
    description: "portal label",
  },
  err_location_required: {
    defaultMessage: "Turn on location to punch.",
    id: "o84nsW",
    description: "portal label",
  },
  err_invalid_sequence: {
    defaultMessage: "This punch cannot follow the previous one.",
    id: "ZwXPvj",
    description: "portal label",
  },
  err_policies_pending: {
    defaultMessage: "Read and acknowledge the documents in force first.",
    id: "oKmsqD",
    description: "portal label",
  },
  err_not_employee: {
    defaultMessage: "Your account has no employee profile.",
    id: "y+hjY5",
    description: "portal label",
  },
  err_vacation_balance: {
    defaultMessage: "Not enough vacation days.",
    id: "TxG0nI",
    description: "portal label",
  },
  err_vacation_not_yet: {
    defaultMessage: "Vacation can only be taken after 6 months of contract.",
    id: "tu9SnK",
    description: "portal label",
  },
  err_already_exists: {
    defaultMessage: "Already exists for that period.",
    id: "8pJHvJ",
    description: "portal label",
  },
  err_required: {
    defaultMessage: "Fill in the required fields.",
    id: "wcwsq0",
    description: "portal label",
  },
  err_invalid: { defaultMessage: "Invalid data.", id: "APNKgi", description: "portal label" },
  err_not_found: { defaultMessage: "Not found.", id: "Nask6z", description: "portal label" },
  alert_annual_overtime_limit: {
    defaultMessage: "Close to the annual overtime limit",
    id: "xfSQJL",
    description: "portal label",
  },
  alert_daily_overtime_limit: {
    defaultMessage: "Daily overtime limit exceeded",
    id: "UnwVXi",
    description: "portal label",
  },
  alert_weekly_balance: {
    defaultMessage: "Weekly balance far from the contracted hours",
    id: "k16taO",
    description: "portal label",
  },
  alert_signature_late: {
    defaultMessage: "Weekly validation overdue",
    id: "J/Yzep",
    description: "portal label",
  },
  alert_signature_disagreed: {
    defaultMessage: "Unresolved disagreement",
    id: "/7pDZj",
    description: "portal label",
  },
  alert_no_record: {
    defaultMessage: "Working day with no punches nor absence",
    id: "Yp0oUd",
    description: "portal label",
  },
  alert_punctuality_pattern: {
    defaultMessage: "Repeated lateness / early leave",
    id: "ExCqJH",
    description: "portal label",
  },
  alert_tolerance_cap: {
    defaultMessage: "Monthly tolerance used up",
    id: "upy4lA",
    description: "portal label",
  },
  alert_unjustified_absences: {
    defaultMessage: "Many unjustified absences this year",
    id: "ZPop0y",
    description: "portal label",
  },
  taskOpen: { defaultMessage: "To do", id: "iGCMTW", description: "portal" },
  taskDone: { defaultMessage: "Done, awaiting approval", id: "bZ3YrJ", description: "portal" },
  taskApproved: { defaultMessage: "Approved", id: "zIOpXv", description: "portal" },
  taskCancelled: { defaultMessage: "Cancelled", id: "FlzxcJ", description: "portal" },
  reportSubmitted: { defaultMessage: "Submitted", id: "VOBLqV", description: "portal" },
  reportReturned: { defaultMessage: "Returned", id: "T4tfDY", description: "portal" },
  recurrence: { defaultMessage: "Repeats", id: "fT/Gyk", description: "portal" },
  recurrenceDaily: { defaultMessage: "Every working day", id: "p1zt79", description: "portal" },
  recurrenceWeekly: { defaultMessage: "Weekly", id: "svSnVJ", description: "portal" },
  recurrenceMonthly: { defaultMessage: "Monthly", id: "Ln/W0K", description: "portal" },
  weekday: { defaultMessage: "Weekday", id: "yooaVr", description: "portal" },
  monthDay: { defaultMessage: "Day of month", id: "OZ6CUr", description: "portal" },
  ruleOfficeNetwork: {
    defaultMessage: "Require the work site's network",
    id: "hSGk6t",
    description: "portal",
  },
  ruleDeviceBinding: {
    defaultMessage: "Each person punches only from their own device",
    id: "r5FBck",
    description: "portal",
  },
  ruleKioskOnly: { defaultMessage: "Kiosk only", id: "wRx/am", description: "portal" },
  rulePinStep: { defaultMessage: "PIN changes every (s)", id: "oOy8MX", description: "portal" },
  err_office_network_required: {
    defaultMessage: "Connect to the work site's Wi-Fi to punch.",
    id: "/Agiel",
    description: "portal",
  },
  err_device_not_registered: {
    defaultMessage:
      "This device is not authorised for your punches; management was told to approve it.",
    id: "Ep+LWH",
    description: "portal",
  },
  err_device_unknown: {
    defaultMessage: "Device not identified: reload the page.",
    id: "HHxOea",
    description: "portal",
  },
  err_kiosk_required: {
    defaultMessage: "Punch on the work site's kiosk.",
    id: "uI4z46",
    description: "portal",
  },
  err_report_required: {
    defaultMessage: "Submit the day's report before signing the day.",
    id: "Xvqkkg",
    description: "portal",
  },
});
